import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import clamp from 'text-overflow-clamp';
import { FormattedMessage } from 'react-intl';

import { VODCSSModules } from 'shared/utils/wix-connect';
import resizeImage from 'widget/player-widget/utils/resize-image';

import settings from 'shared/settings';

import ScrollbarWrapper from 'widget/player-widget/components/scrollbar-wrapper/scrollbar-wrapper';

import styles from './info.styl';

import translations from '../../../player/info-overlay/info/translations';
import crewTranslations from 'shared/translations/crew';
import genreTranslations from 'shared/translations/genres';


const POSTER_SIZE = {
  width: 303,
  height: 449,
};

const POSTER_SIZE_FULLSCREEN = {
  width: 450,
  height: 667,
};

@VODCSSModules(styles)
export default class InfoOverlayInfo extends React.Component {

  static propTypes = {
    title: React.PropTypes.string,
    publisher: React.PropTypes.string,
    posterUrl: React.PropTypes.string,
    description: React.PropTypes.string,
    durationStr: React.PropTypes.string,
    genre: React.PropTypes.string,
    cast: React.PropTypes.array,
    crew: React.PropTypes.array,
    isInFullScreen: React.PropTypes.bool,
  };

  componentDidMount() {
    this.clamp();

    window.addEventListener('resize', this.setPosterSize);
    this.setPosterSize();
  }

  componentDidUpdate() {
    this.clamp();
    this.setPosterSize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setPosterSize);
  }

  title = null;
  info = null;
  posterEl = null;

  @autobind
  savePosterRef(node) {
    this.posterEl = node;
  }

  @autobind
  saveTitleRef(node) {
    this.title = node;
  }

  clamp() {
    clamp(this.title, { lineClamp: 3 });
  }

  getRoles(rolesType) {
    const { [rolesType]: roles } = this.props;

    if (!roles || !roles.length) {
      return null;
    }

    const roleElements = _.map(roles, function ({ role, name }, index) {
      if (rolesType === 'crew') {
        role = (
          <FormattedMessage {...crewTranslations[role]} />
        );
      }

      return (
        <div key={index}
             styleName="role-item"
             className={`qa-overlay-info-${rolesType}`}>
          <div styleName="role">{role}</div>
          <div styleName="name">{name}</div>
        </div>
      );
    });

    return (
      <div styleName="roles-wrapper">
        <div styleName="roles-title">
          <FormattedMessage {...translations[rolesType]} />
        </div>

        {roleElements}
      </div>
    );
  }

  @autobind
  setPosterSize() {
    const { isInFullScreen } = this.props;
    this.updatePosterStyle(isInFullScreen ? POSTER_SIZE_FULLSCREEN : POSTER_SIZE);
  }

  updatePosterStyle({ width, height }) {
    const poster = this.posterEl;

    if (!poster) {
      return null;
    }

    poster.style.width = `${Math.floor(poster.offsetHeight / height * width)}px`;
  }

  getPosterImage(width, height, className) {
    const { posterUrl, isInFullScreen } = this.props;
    const { hosts } = settings;

    if (!posterUrl) {
      return null;
    }

    const resizedPosterUrl = resizeImage(posterUrl, width * 2, height * 2);

    return (
      <div ref={this.savePosterRef}
           styleName={classnames('poster', className, { fullscreen: isInFullScreen })}
           className="qa-overlay-info-poster"
           style={{ backgroundImage: `url(${hosts.image}${resizedPosterUrl})` }} />
    );
  }

  get compactPoster() {
    const { posterUrl, title } = this.props;

    if (!posterUrl) {
      return null;
    }

    const resizedPosterUrl = resizeImage(posterUrl, POSTER_SIZE.width * 2, POSTER_SIZE.height * 2);

    const { hosts } = settings;

    return (
      <img styleName="poster poster-compact"
           className="qa-overlay-info-poster-compact"
           src={`${hosts.image}${resizedPosterUrl}`}
           alt={title} />
    );
  }

  get poster() {
    const { isInFullScreen } = this.props;

    if (isInFullScreen) {
      return null;
    }

    return this.getPosterImage(POSTER_SIZE.width, POSTER_SIZE.height);
  }

  get fullScreenPoster() {
    const { isInFullScreen } = this.props;

    if (!isInFullScreen) {
      return null;
    }

    return this.getPosterImage(POSTER_SIZE_FULLSCREEN.width, POSTER_SIZE_FULLSCREEN.height);
  }

  get publisher() {
    const { publisher } = this.props;

    if (!publisher) {
      return null;
    }

    return (
      <div styleName="info-item"
           className="qa-overlay-info-publisher">
        <FormattedMessage {...translations.publisher}
                          values={{ author: publisher }} />
      </div>
    );
  }

  get genres() {
    const { genre } = this.props;

    if (!genre) {
      return null;
    }

    return (
      <div styleName="info-item"
           className="qa-overlay-info-genres">
        <FormattedMessage {...genreTranslations[genre]} />
      </div>
    );
  }

  get duration() {
    const { durationStr } = this.props;

    if (!durationStr) {
      return null;
    }

    return (
      <div styleName="info-item"
           className="qa-overlay-info-duration">
        {` ${durationStr}`}
      </div>
    );
  }

  get description() {
    const { description } = this.props;

    if (!description) {
      return null;
    }

    return (
      <div styleName="description"
           className="qa-overlay-info-description">
        {description}
      </div>
    );
  }

  render() {
    const { title, isInFullScreen } = this.props;

    const styleNames = classnames('wrapper', {
      'full-screen': isInFullScreen,
    });

    return (
      <div styleName={styleNames}
           className="qa-player-overlay-info">
        {this.poster}

        <ScrollbarWrapper styleName="scrollbar-wrapper">
          <div styleName="main-info">
            <div ref={this.saveTitleRef}
                 styleName="title"
                 className="qa-overlay-info-title"
                 title={title}>
              {title}
            </div>

            <div styleName="info">
              {this.publisher}
              {this.genres}
              {this.duration}
            </div>

            {this.description}
            {this.fullScreenPoster}

            {this.getRoles('cast')}
            {this.getRoles('crew')}
            {this.compactPoster}
          </div>
        </ScrollbarWrapper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/info/info.js